import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=3832490e"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports